import { render } from "./MalfunctionReportsModule.vue?vue&type=template&id=1b71d38b&scoped=true"
import script from "./MalfunctionReportsModule.vue?vue&type=script&lang=js"
export * from "./MalfunctionReportsModule.vue?vue&type=script&lang=js"

import "./MalfunctionReportsModule.vue?vue&type=style&index=0&id=1b71d38b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b71d38b"]])

export default __exports__